import { Injectable } from "@angular/core";

export class ViewSummaryItem{
    ViewID:string;
    ViewName:string;
    ChildCount:number;
    IsSystemView:boolean;
    ChildList:ViewSummaryItem[];
    ViewOrder:number;
}

@Injectable( {providedIn:'root'} )
export class View {
    currentView?: string;
}

export class DocumentOutline {
    ItemId: string;
    ItemType: string;
    ItemDisplay: string;
    ChildCount: number;
    ViewOrder: number;
    ChildList: DocumentOutline[];
}